<template>
  <div class="c-allocationCompleted">
    <PageTitle titleText="申込み完了" asideText="申込みを完了しました。" />
    <div
      @click="$router.push({ name: 'allocation-index' })"
      class="c-allocationCompleted__buttonWrap"
    >
      <div class="c-allocationCompleted__button">
        <Button text="一覧にもどる"></Button>
      </div>
    </div>
  </div>
</template>
<script>
import Button from "@/components/Button.vue";
import PageTitle from "@/components/PageTitle.vue";

export default {
  name: "AllocationCompleted",
  components: {
    Button,
    PageTitle,
  },
};
</script>
